import { splitParentSummary } from './pursuit/splitParentSummary.js'
import { ownerName } from '../../lib/championships.js'
const dateOf = record => { const value = Date.parse(record.effDate); return Number.isFinite(value) ? value : null }
export function focusOpportunities(items, focus, now = new Date()) {
  const today = new Date(now); today.setHours(0, 0, 0, 0)
  const end = new Date(today); end.setDate(end.getDate() + 14)
  return items.filter(record => {
    const family = splitParentSummary(record)
    if (focus === 'reconciliation') return Boolean(family && !family.complete)
    if (family && ['champion', 'crowned'].includes(focus)) return false
    const date = dateOf(record), winner = Boolean(record.champion || record.winningSchool)
    if (focus === 'upcoming') return date != null && date >= today && date <= end
    if (focus === 'champion') return date != null && date < today && !winner
    if (focus === 'crowned') return winner
    if (focus === 'undated') return date == null
    if (focus === 'unassigned') return !ownerName(record)
    return true
  })
}
export function sortOpportunities(items, order, now = new Date()) {
  const rank = record => {
    const date = dateOf(record)
    if (date == null) return Infinity
    return order === 'date' ? date : Math.abs(date - now)
  }
  return [...items].sort((a, b) => {
    const named = String(a.name || '').localeCompare(String(b.name || ''))
    if (order === 'name') return named
    if (order === 'owner') return ownerName(a).localeCompare(ownerName(b)) || named
    return rank(a) - rank(b) || named
  })
}
